<script setup lang="ts">
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const { load: loadGoogleBusinessInformation, data: googleBusinessInformationData } = useGoogleBusinessInformation()

const storePages = computed(() => layoutData.value?.storePages?.urls || [])

const stores = computed(() => {
  return storePages.value.map((store: any) => {
    const googleBusinessInformationId = store?.filters.find((s: any) => s.key === 'GoogleBusinessInformationID')?.values?.[0] || {}
    const today = googleBusinessInformationData.value?.find((info: any) => info.id === googleBusinessInformationId)?.today?.current?.[0] || null
    return {
      ...store,
      today,
      isOpen: isStoreCurrentlyOpen(today),
    }
  }) || []
})

const openStores = computed(() => stores.value.filter((store: any) => store.isOpen))
const openStoresToday = computed(() => stores.value.filter((store: any) => store.today?.open))

const isOpen = computed(() => openStores.value.length > 0)

onMounted(() => {
  loadGoogleBusinessInformation()
})
</script>

<template>
  <div
    v-if="googleBusinessInformationData"
    class="opening-hours"
    :class="{ 'opening-hours--open': isOpen }"
  >
    <template v-if="stores.length === 1">
      <AppLink :to="stores[0].url">
        <span v-if="stores[0].isOpen">Vandaag geopend tot {{ stores[0].today.close_time }}</span>
        <span v-else-if="stores[0]?.today?.open">Vandaag geopend van {{ stores[0].today.open_time }} tot {{ stores[0].today.close_time }}</span>
        <span v-else>Vandaag gesloten, bekijk openingstijden</span>
      </AppLink>
    </template>
    <span v-else-if="openStoresToday.length > 1">Vandaag open in
      <span
        v-for="(item, i) in openStoresToday"
        :key="item.url"
      >
        <AppLink :to="item.url">
          {{ item.label }}
        </AppLink>
        <span v-if="i < openStoresToday.length - 1">, </span>
      </span>
    </span>
    <span v-else>Vandaag gesloten <AppLink to="/winkels/"><!-- WBP /poortvliet/, BP /winkels/ -->
      Bekijk openingstijden
    </AppLink></span>
  </div>
</template>

<style>
@import url("~layers/app/components/App/OpeningHours.css");
</style>
